import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckIcon,
  CopyIcon,
  FacebookIcon,
  ShareButton,
  WhatsAppIcon,
  XIcon,
} from '../../atoms';
import styles from './share-box.module.css';

export interface ShareBoxProps {
  url: string;
}

export const ShareBox: FC<ShareBoxProps> = memo(({ url }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'ui.share' });
  const [copied, setCopied] = useState(false);

  const handleCopyToClipboard = (e: any) => {
    e.stopPropagation();
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={styles.shareBox}>
      <p className={styles.title}>{t('share')}</p>
      <div className={styles.shareButtons}>
        <ShareButton
          icon={<FacebookIcon />}
          shareUrl={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url,
          )}`}
          ariaLabel={t('facebook')}
        />
        <ShareButton
          icon={<XIcon />}
          shareUrl={`https://x.com/intent/tweet?url=${encodeURIComponent(url)}`}
          ariaLabel={t('x')}
        />
        <ShareButton
          icon={<WhatsAppIcon />}
          shareUrl={`https://wa.me/?text=${encodeURIComponent(url)}`}
          ariaLabel={t('whatsapp')}
        />
      </div>
      <div className={styles.copyUrl}>
        <input type="text" value={url} readOnly />
        <button
          onClick={handleCopyToClipboard}
          aria-label={t('copyUrl')}
          className={styles.copyButton}
        >
          {copied ? <CheckIcon /> : <CopyIcon />}
        </button>
      </div>
    </div>
  );
});

ShareBox.displayName = 'ShareBox';
